import '../assets/styles/Painel.css';
import BotaoZap from './BotaoZap';

export default function Painel({
  titulo,
  descricao,
  imagem,
  alt,
  cor = '#f4f4f4',
  corTexto = '#333',
  textoBotao = 'Fale com um especialista',
}) {
  return (
    <section className="painel" style={{ backgroundColor: cor }}>
      <div className="painel-container">
        <div className="painel-text" style={{ color: corTexto }}>
          <h2 dangerouslySetInnerHTML={{ __html: titulo }} />
          <p dangerouslySetInnerHTML={{ __html: descricao }} />
          <BotaoZap texto={textoBotao} />
        </div>
        {imagem && (
          <div className="painel-image">
            <img src={imagem} alt={alt || 'imagem ilustrativa'} />
          </div>
        )}
      </div>
    </section>
  );
}